import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

// Services
import EventService from '../../services/event-service';
import ClassroomService from '../../services/classroom-service';
import SchoolService from '../../services/school-service';
import StorageService from '../../services/storage-service';
import FileStorageService from '../../services/file-storage-service';

// Containers
import EventFollow from './event-follow';
import EventEdit from './event-edit';

// Components
import Loading from '../../components/loading/loading';
import ErrorComponent from '../../components/error/error';

const EventEditFollow = () => {
  const { eventId } = useParams<{ eventId: string }>();
  const [error, setError] = useState(false);

  const [active, setActive] = useState<boolean | null>(null);
  const [event, setEvent] = useState<EventDto>(null);
  const [eventDetail, setEventDetail] = useState<BackofficeEventDetailDto>(null);
  const [classroomList, setClassroomList] = useState<ClassroomStudents[] | null>(null);
  const [eventService, setEventService] = useState<EventService | null>(null);
  const [fileStorageService, setFileStorageService] = useState<FileStorageService | null>(null);

  useEffect(() => {
    const schoolService = new SchoolService();
    const storageService = new StorageService();
    const schoolId = storageService.getEmployee().schoolId;

    let service: EventService;

    schoolService
      .getSchoolById(schoolId)
      .then((school) => {
        service = new EventService(school.uuid);

        setEventService(service);
        setFileStorageService(new FileStorageService(school.uuid));

        return service.getBackoffice(eventId);
      })
      .then((detail) => {
        setActive(detail.isScheduled);

        if (detail.isScheduled) {
          // A edição usa a rota canônica: o PUT substitui imageFileId e studentUuids
          // por completo, então o formulário precisa deles crus.
          const classroomService = new ClassroomService();

          return Promise.all([
            service.getEvent(eventId),
            classroomService.listClassroomStudents(),
          ]).then(([fullEvent, classrooms]) => {
            setEvent(fullEvent);
            setClassroomList(classrooms);
          });
        }

        setEventDetail(detail);
      })
      .catch(() => setError(true));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (error) return <ErrorComponent type='contentFull' />;

  if (active === null || !eventService || !fileStorageService)
    return <Loading type='contentFull' />;

  if (active) {
    if (!event || !classroomList) return <Loading type='contentFull' />;

    return (
      <EventEdit
        event={event}
        classroomList={classroomList}
        eventService={eventService}
        fileStorageService={fileStorageService}
      />
    );
  }

  if (!eventDetail) return <Loading type='contentFull' />;

  return <EventFollow event={eventDetail} eventService={eventService} />;
};

export default EventEditFollow;
